import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

/**
 * Footer component
 */
export class FooterComponent implements OnInit {
  appName: String = environment.project.name;
  uiVersion: string = environment.version?.ui || 'N/A';
  apiVersion: string = 'N/A';

  // set the currenr year
  year: number = new Date().getFullYear();

  constructor(private authenticationService: AuthenticationService) { }

  ngOnInit() {
    this.authenticationService.getApiVersion().subscribe({
      next: (response: any) => {
        this.apiVersion = response?.data?.version || 'N/A';
      },
      error: () => {
        this.apiVersion = 'N/A';
      }
    });
  }

}
